<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">文章管理</div>
        </div>

        <!-- <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">用戶名</label>
                    <Input size="small" v-model="form.username"/>
                </FormItem>
                <FormItem>
                    <label class="input-label">手機號碼</label>
                    <Input size="small" v-model="form.phone"/>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <div class="pg-btn style2">導出excel</div>
                    </div>
                </FormItem>
            </Form>
        </div> -->

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
				   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <!-- <div class="pg-btn style1" @click="handleDelete(index)">删除</div> -->
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
                isSubmiting: false,
				// form: {
				//     username: '',
				//     phone: ''
				// },
                table: {
                    column: [
                        {
                            title: '文章ID',
                            key: 'id',
                            align: 'center',
							sortable: true,
                            minWidth: 50
                        },
						{
						    title: '標題',
						    key: 'title',
						    align: 'center',
							sortable: true,
						    minWidth: 150
						},
                        // {
                            // title: '正文',
                            // key: 'content',
                            // align: 'center',
							// sortable: true,
                            // width: 150
                        // },
                        {
                            title: '修改時間',
                            key: 'update_time',
                            align: 'center',
							sortable: true,
                            minWidth: 160
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 150
                        }
                    ],
                    data: []
                }
            };
        },
        activated() {
            this.getList();
        },
        mounted() {
            this.getList();
        },
        methods: {
            getList() {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.articleList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {
                            tempArr.push({
								id: resData[i].id,
                                title: resData[i].title,
                                // content: resData[i].content,
                                create_user: resData[i].create_user,
                                cid: resData[i].cid,
								created_at: resData[i].created_at,
								update_time: resData[i].update_time,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
			handleDelete(index) {
			    this.$Modal.confirm({
			        title: '提示',
			        content: '確定刪除嗎？',
			        cancelText: '取消',
			        okText: '確定',
			        onOk: () => {
			            let tableData = this.table.data;
			            this.isSubmiting = true;
			            this.$Rq.requestAuth({
			                url: this.$Api.articleDelete + '/' + tableData[index].id,
			                method: 'delete',
			            }).then((res) => {
			                this.isSubmiting = false;
			                if (res.code == 0) {
			                    this.$Utils.showSuccess(res.msg);
			                    this.pageIndex = 1;
			                    this.getList();
			                } else {
			                    this.$Utils.showTipInfo(res.msg);
			                }
			            }).catch((err) => {
			                this.isSubmiting = false;
			            });
			        }
			    });
			},
            handleToAdd() {
                this.$router.push({path: '/articleManageAdd'});
            },
            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
            handleEdit(index) {
                let tableData = this.table.data;
                this.$router.push({path: '/articleManageEdit?id=' + tableData[index].id})
            },
            //pager
            handlePageSizeChange(value) {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput() {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount) {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter() {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0) {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value) {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'articleManage.scss';
</style>